import axios from 'axios';

const createApiClient = (URL, METHOD, BODY) => {
  // Create base configuration for axios
  const axiosInstance = axios.create({
    baseURL: URL,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  });

  // Add request interceptor for logging or manipulation if needed
  axiosInstance.interceptors.request.use(
    config => {
      // You can add logging or request manipulation here
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );

  // Add response interceptor for handling common response patterns
  axiosInstance.interceptors.response.use(
    response => {
      // Return just the data part of the response
      return response;
    },
    error => {
      console.error(`API request failed: ${error.message}`);
      
      // Enhanced error handling with response details when available
      if (error.response) {
        console.error(`Status: ${error.response.status}`);
        console.error(`Response data:`, error.response);
      }
      
      return Promise.reject(error);
    }
  );

  // Return an object with methods for different HTTP verbs
  return {
    get: (endpoint, params = {}) => {
      return axiosInstance.get(endpoint, { params });
    },
    
    post: (endpoint, data = {}) => {
      return axiosInstance.post(endpoint, data);
    },
    
    put: (endpoint, data = {}) => {
      return axiosInstance.put(endpoint, data);
    },
    
    delete: (endpoint, params = {}) => {
      return axiosInstance.delete(endpoint, { params });
    }
  };
};

export { createApiClient };